import { TLiftedFormModel } from '../../model/form.model';
import { TAttachmentDetails, TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN } from '@monorepo/types';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import moment from 'moment';

export type TUpdateAttachmentFormPayload = {
  attachmentSerialNumber: string;
  brand: string[];
  machineCategory: string[];
  machineSubCategory: string[];
  machineType: string[];
};

export const UPDATE_ATTACHMENT_FORM_MODEL = {
  createModel: (
    attachment: TAttachmentDetails,
    dropdownList: TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN,
  ): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: attachment.attachmentType,
          },
          metadata: {
            keyName: 'attachmentStatus',
            label: 'table_model.ATTACHMENT_TYPE',
            isReadonly: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: attachment.status,
          },
          metadata: {
            keyName: 'attachmentStatus',
            label: 'update_machine.MachineStatus',
            isReadonly: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: attachment.serialNumber,
          },
          metadata: {
            keyName: 'attachmentSerialNumber',
            label: 'attachment.SerialNumber',
            isReadonly: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            value: [attachment.machineType],
            options: dropdownList.machineTypes.map((mT) => ({ value: mT, displayName: mT })),
          },
          metadata: {
            keyName: 'machineType',
            label: 'update_machine.MachineType',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            value: [attachment.machineCategory],
            options: dropdownList.machineCategories.map((mC) => ({ value: mC, displayName: mC })),
          },
          metadata: {
            keyName: 'machineCategory',
            label: 'update_machine.MachineCategory',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            value: attachment.machineSubCategory ? [attachment.machineSubCategory] : [],
            options: dropdownList.machineSubCategories.map((mSC) => ({ value: mSC, displayName: mSC })),
          },
          metadata: {
            keyName: 'machineSubCategory',
            label: 'update_machine.MachineSubCategory',
            isRequired: false,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            value: [attachment.machineBrand],
            options: dropdownList.brands.map((b) => ({ value: b, displayName: b })),
          },
          metadata: {
            keyName: 'brand',
            label: 'update_machine.Brand',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: moment(attachment.lastUpdatedOn).format('hh:mm A, DD/MM/YYYY'),
          },
          metadata: {
            keyName: 'lastUpdatedOn',
            label: 'attachment.LastUpdatedOn',
            isReadonly: true,
          },
        },
      ],
    });
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
